import { CurrentPromosResponse, GetActivePromoResponse } from "../../interfaces/promo"

export const usePromoFetch = () => {

    const getCountryPromo = async (country_id : number) => {

        const url = process.env.REACT_APP_AUTH_API_URL + '/api/promos/get-active-promo?country_id=' + country_id
        let response : GetActivePromoResponse = await fetch(
            url,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache'
                },
            }
        ).then(data => data.json()).catch(err => {
            return {
                error : err.toString()
            }
        })

        return response;
    }

    const getCurrentPromos = async (country_id: number): Promise<CurrentPromosResponse> => {
        const empty = {
            popup: null,
            preheader: null,
            preheaders: [],
            counter_popup: null,
            event: null,
        } as CurrentPromosResponse['data']
        const base = process.env.REACT_APP_AUTH_API_URL
        if (base == null || base === '' || !Number.isFinite(country_id) || country_id < 1) {
            return { success: false, message: '', data: empty, errors: [] }
        }
        try {
            const res = await fetch(`${base}/api/promos/current-promos`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
                body: JSON.stringify({ country_id, platform: 'iris' }),
            })
            return (await res.json()) as CurrentPromosResponse
        } catch (err) {
            return {
                success: false,
                message: String(err),
                data: empty,
                errors: [String(err)],
            }
        }
    }

    return {
        getCountryPromo,
        getCurrentPromos,
    }
}